import Swiper from 'swiper';

// Mob slider
{
	const swiper = new Swiper('.js-cities__slider .swiper', {
		slidesPerView: 'auto',
	});
}

// Center city after scroll
{
	const citiesWrap = document.querySelector('.js-cities__cities-wrap');
	const cityTitle = document.querySelector('.js-cities__title');
	const cityListWrap = document.querySelector('.js-cities__list-wrap');
	const cityNames = document.querySelectorAll('.js-cities__city');
	const cityPictures = document.querySelectorAll('.js-cities__pic');

	if (citiesWrap && cityTitle && cityListWrap && cityNames.length > 0 && cityPictures.length > 0) {
		const getStylesOfElement = (element) => element.currentStyle || window.getComputedStyle(element);

		const removeOldClassPrevAndNext = () => {
			const prevNextElements = document.querySelectorAll('.js-cities__city.prev, .js-cities__city.next');

			Array.from(prevNextElements).forEach((el) => {
				el.classList.remove('prev', 'next');
			});
		};

		const addClassPrevAndNext = () => {
			const activeCity = document.querySelector('.js-cities__city.active');
			const prevElement = activeCity.previousElementSibling;
			const nextElement = activeCity.nextElementSibling;

			prevElement?.classList.add('prev');
			nextElement?.classList.add('next');
		};

		const getVisibleHeightOfCities = () => {
			const citiesWrapHeight = citiesWrap.offsetHeight;
			const cityTitleHeight = cityTitle.offsetHeight;
			const stylesOfCityTitle = getStylesOfElement(cityTitle);
			const cityListVisibleHeigh =
				citiesWrapHeight - cityTitleHeight - parseInt(stylesOfCityTitle.marginBottom, 10);

			return cityListVisibleHeigh;
		};

		const setHeightToCityList = () => {
			cityListWrap.style.removeProperty('--list-height'); // first reset height for correct calculate
			cityListWrap.style.setProperty('--list-height', `${getVisibleHeightOfCities()}px`);
		};

		const changeActiveCity = (index) => {
			const activeCity = document.querySelector('.js-cities__city.active');
			activeCity.classList.remove('active');
			cityNames[index].classList.add('active');
		};

		let prevActivePicIndex = 0;

		const changeActivePic = (index) => {
			if (prevActivePicIndex !== index) {
				if (prevActivePicIndex > index) {
					for (let i = prevActivePicIndex; i > index; i -= 1) {
						cityPictures[i].classList.remove('active');
					}
				} else {
					for (let i = 0; i <= index; i += 1) {
						cityPictures[i].classList.add('active');
					}
				}
			}

			prevActivePicIndex = index;
		};

		const centerToActiveCity = () => {
			const cityListVisibleHeigh = getVisibleHeightOfCities();
			const activeCity = document.querySelector('.js-cities__city.active');
			const topActiveSpace = activeCity.offsetTop;
			const scrollToActiveCityCenter = topActiveSpace - cityListVisibleHeigh / 2 + activeCity.offsetHeight / 2;

			cityListWrap.scrollTo({
				top: scrollToActiveCityCenter,
				behavior: 'smooth',
			});
		};

		const initEvents = () => {
			Array.from(cityNames).forEach((city, index) => {
				city.addEventListener('click', () => {
					changeActiveCity(index);
					changeActivePic(index);
					centerToActiveCity();
					removeOldClassPrevAndNext();
					addClassPrevAndNext();
				});
			});
		};

		const update = () => {
			setHeightToCityList();
			centerToActiveCity();
			removeOldClassPrevAndNext();
			addClassPrevAndNext();
		};

		const init = () => {
			initEvents();
			setHeightToCityList();
			addClassPrevAndNext();
		};

		init();

		window.addEventListener('resize', () => {
			update();
		});
	}
}
